<template>
  <div class="wenti_box">
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          消防安全培训的操作步骤是什么？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          1、打开深i企首页（三端均可），选择【消防培训】。
          2、用户登录。法定代表人登录后将自动绑定名下企业；个人用户需申请绑定企业，将申请信息发送给法人进行授权。
          3、认证通过后返回到企业消防培训页面，再次单击“开始培训”进入到视频播放页面。
          4、点击播放按钮，完整看完所有视频后将会弹出提示“视频播放完毕，进入答题环节”，点击“确定”后进入消防培训答题环节。
          5、答题结束后会展示本次消防培训结果合格，可以进行图片保存，同时可以返回首页以及重新观看视频。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">消防安全</div>
        <div class="time">2021-10-13 11:14:24</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          登录、授权或其他使用异常，如何联系人工服务？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          请通过电话联系深I企客服热线0755-27038037（法定工作日）。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">消防安全</div>
        <div class="time">2021-10-13 11:14:24</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          中途退出了培训页面，重新点击培训是否要重新开始，还是说会保留在上次退出的页面继续即可？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          如果中途退出了，再次培训时需要从头开始学习视频。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">消防安全</div>
        <div class="time">2021-10-13 11:14:24</div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">
        <div class="title-icon"></div>
        <div class="questions">
          如一家企业经办人绑定多家企业，观看一次培训是否多家企业通过培训？
        </div>
      </div>
      <div class="content">
        <div class="answers-icon"></div>
        <div class="answers less">
          如果当前登录系统的个人是企业的经办人（即申请绑定企业并得到法定代表人审核的），则通过该次培训后，只有当前经办的企业认为通过培训（如王小芳是行政人员，是3家企业的经办人，当前为A公司权限参加培训，培训一次后，只有A公司是通过的，其他2家公司需要单独再培训）。
        </div>
      </div>
      <div class="bottom">
        <div class="item-tag">消防安全</div>
        <div class="time">2021-10-13 11:14:24</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.wenti_box {
  width: 1438px;
  background: #fff;
  .list-item {
    box-shadow: 0 1px 0 0 #eee;
    padding-bottom: 16px;
    margin: 16px 24px 17px 24px;
    box-sizing: border-box;
    padding: 12px 0 12px 0;
    .title {
      height: 33px;
      line-height: 33px;
      display: flex;
      .title-icon {
        width: 32px;
        height: 32px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADcklEQVRYCb1XzWsTQRR/bybtNjGxFltBsbYKolBbvCl4qSDkpNCbH2cvCv4HQqFnL1696EFQvIi3ioIXP1DQ4gcoVGxVtG0aKzYx2WZnnvM2TdxsJ+tuwQwk+z5/v7czuzP7EEKD3h/Lrbk0JAgHUEAaSMlQSDIVpSINFY1U6HZwHg8+Xg0CYEMhmhTwZnpEEQ03bP/jKhHnYDT/DnFSM75fAJN7M9NHUdD2/0EaxiSNxdTh/DMuQvhOc+edImc+n8tw+jKvuXLVOCudHtKRjwQ/cJ0mbvD5Dzs/7Q1Dp6/MLfxXrdPM63zMnUr8niOJcnF2olYrj5PSgwTgP8iIUEOUc06671a6d8+LWPdk9phUrEAOUp6zujJ71vPcI6TVrnAeEXQRqf2V8vJl45uKW0T9NQyjWfSfxQ8Xamu/J2zk4XC3snI6bGunx54B7blH/4KY/cssYMsw+y2AWRD+JzXsCzH+YhdgKLtB5iA9dhNS/ScMdPiIUOAtP4DK63NmuVq2+8gyQrcRESvkfPeei4Y8byHnPOn7OAal/BSB1OKKXYDjbLuNmb0tyTZFbNlHTs/2mzafzRa7gEzf0NPu3IEZG0jQ1pUbeZnu3f0qaIuSYxfAIKJnZyEKzI9x+n/8KyboT1QAabccTLbJcWKCeYkKENX52WCyTY4TE8xLVAAWrj0HqC4EAVrl6kI9ptUapSUqANyvVVm4cUWT8sKgbGMfx4R9UXqyAgwSLl3/UFz8/PFXqQxVd83/sexVih/ZF0Vm88XeCYEwJQUc0oSD4C3mfq1mfTwpBPRvy0IWV3IaxEmB9EVpeAtIG2Zp0wUgiDFz3F7SBDsYpE89gfLWEXC6UpDNOMBF6G/3+YQ8bwoEgbBEgFcJ9GsbadAmzL6pgoawLFHmDfmUOWZ8cvanS3dhQD+ErZmU+RhQQMW7AMt3mqkcyzmc2zTaBMONtZljxxFVfT5DQYhipzngrhqzE3LVVVxfwfaz7ZoP/0tE+rstn0iWBHcsNifbEPCMudjJOYCJ25NzhLOOwfKGwdyC26UNnqaBRpvipoX2GMwtuFfz2yU7QZ/dnMhqxWBO5q7vA6ZX43YpDGu+8xLvE3EwfC7DybE+Afdo3KtFzEQYd9M6czT6QgYxX1qtI9iem43nHhFZ35DWrPYaIpbMxnSqXXv+B3sISmgfMuYOAAAAAElFTkSuQmCC);
      }
      .questions {
        font-family: PingFangSC-Medium;
        margin-left: 16px;
        font-size: 20px;
        line-height: 33px;
        color: #333;
        letter-spacing: 0;
      }
    }
    .content {
      margin-top: 20px;
      line-height: 30px;
      display: flex;
      .answers-icon {
        width: 32px;
        height: 32px;
        background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAIKADAAQAAAABAAAAIAAAAACPTkDJAAADpElEQVRYCcVXTWgTQRT+ZtNUbRITa021SlH6B/5BqRYUFfyr9OBRRFAQLYiCBz0J4t2LoofSS714Ek9eROmhVEVBPYg/VZRaaZX+JzZNappkN+N702wqqdnsSlIfbHZ2dub73vvezNuMQI6NRuUWCXQIoA0StdT25gxx9Eg4MQgME04PtbvX+UT/nwDUN29SyvKxGG7S03kpoZn9xbwLgTThda314rIQIsnYyoEM+SMiPlBMwnxY5EgvOdHOTqhIOfKlImenmCujNgTnnPrelUp2CxU4HdvLeMHRYitJzvORc78KWKBDo0XQZjWwlO+YW+OtVkoSS2zi5hRY7nNt+idckWkYqyrhCk8htbEuixma0fH8cwyD4wmMR1Ko9rtRt3YZdjd5sdpXlh2Xr8HcYmSGsmFha65fI+IQpMcDbTaGqYtX8DYdxLOPUfQPxyFo9ZSVCQQDboSiOoy0BG0vbK1dgV2NXjStX26BTnMt39LL5KZ6VFDkgsgNnx96ZRVud49BuICa1eU43OxHS70H5eREypB4M/gLfR9m8H7ol7punLbOcEEHIsdOQSSTKB8aROjcJaXEQSJtrq9AQ818dBMRHS8pFTsaPGjNXJyWj9/jheJDwRQwgqGn4Y7HoHtXgrdNrr36Mou7vZM4vq8KezdbLqncqfb2/4Vb33Di9gTeDswuAlAdtIoMkl9S/tnuPQuj731UtQv92CpAaQNIpahw5Vmu9C0Bj+HXfL34FMU7WgN2zJYDHJ2KMK8DQJqiNxXQKWWS5tgxew5Q8GmWOIOYSEpcvTOM+30h1cMbmR00TfL4hUez+6/3gruAZzHgnwokdImBH3MIeOanmyl4/HoaLz/RdqXxK9y2YitcB0y3VbnK1CzeCKyIGaWpwGgoiYnpFNZQRWzfGTCnWt5tKWAiZFVlyUkFdsI0g8I+eaga+5tXqqJk9he629MpB4Vp05xnuthUzqntIjSuiE7snxzwVWhwE9HnoTjic7TiiVE5tCCIbR8cpcBEpW8NDrYE8PBFGGevf4Xf61IpefCUCtCbCH2gBDQK7ciOAPZs85nT/nq35UBbqx9h+tJtCC7Lgpw5GlQqPCHCkckENNJ/PJzAZITJBVwugVCjnh2fryFGZ2SUlHNWwPOhOewnIWMaHxoczivecOLWKPqe4iE6Q2Lu//63XMuc1bqc+V6U0V3MrarGfz+a8Rlt/qyGzswBsigh5oIwNl2d5rmQ3y+qm0t9PP8N5ESUFHS19TYAAAAASUVORK5CYII=);
      }
      .answers {
        width: 1100px;
        padding-left: 16px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #666;
        line-height: 30px;
        font-weight: 400;
      }
      .less {
        width: 1075px;
      }
      .zoom {
        align-self: flex-end;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #1072e0;
        text-align: right;
        cursor: pointer;
      }
    }
    .bottom {
      height: 30px;
      line-height: 30px;
      margin-top: 15px;
      display: flex;
      margin-left: 48px;
      align-items: center;
      .item-tag {
        min-width: 64px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        padding: 0 8px;
        background: #e8f0ff;
        border-radius: 12px;
        font-size: 12px;
        color: #1072e0;
      }
      .time {
        margin-left: 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666;
        letter-spacing: 0;
      }
    }
  }
}
</style>
